import * as Models from './webgiving-generated';
import { IWebGivingPaymentState, defaultPaymentState } from './webgiving-payment-state';
import { IPagePaymentSuccessData } from './pages/page-payment-success/page-payment-success-view-model';

export interface IWebGivingAppState {
	fromRecurringSuggestion: boolean;
	person: Models.WebGivingPersonModel | null;
	confirmedMobileNumber: Models.WebGivingMobileNumber | null;
	mobileNumberRequest: IWebGivingMobileNumberRequest | null;
	paymentState: IWebGivingPaymentState;
	rememberMe: boolean;
	previousPaymentThankYouPageDetails: IPagePaymentSuccessData | null;
	userPrefersVoiceCalls: boolean;
	correlationId: string;
	userWasCreated: boolean;
	recurringSuggestion: Models.RecurringSuggestionQueryResult | null;
	recurringSuggestionId: number | null;
	appContentCards: Models.AppContentCardModel[] | null;
}

export interface IWebGivingMobileNumberRequest {
	mobileNumber: Models.WebGivingMobileNumber;
	mobileRequestToken: string;
}

export function defaultAppState(viewData: Models.WebGivingViewModel, rememberedAmount: number | undefined): IWebGivingAppState {
	const person = viewData.Person;

	return {
		person,
		confirmedMobileNumber: viewData.ConfirmedMobileNumber || (person && person.MobileNumber),
		mobileNumberRequest: null,
		paymentState: defaultPaymentState(viewData, true, rememberedAmount),
		rememberMe: viewData.ClientIsMobilePhone || person instanceof Object,
		previousPaymentThankYouPageDetails: null,
		userPrefersVoiceCalls: false,
		correlationId: viewData.SessionCorrelationId,
		userWasCreated: false,
		recurringSuggestion: null,
		recurringSuggestionId: null,
		fromRecurringSuggestion: false,
		appContentCards: null,
	};
}

export function userShouldReceiveWelcomeSMS(appState: IWebGivingAppState, viewData: Models.WebGivingViewModel) {
	return !viewData.ClientIsMobilePhone && !appState.userPrefersVoiceCalls && appState.userWasCreated;
}
